
export default {
  props: ["headerData"],
  data() {
    return {
      isShow: false,
      searchVal: "",
      languageIsShow: true,
    };
  },
  methods: {
    updataShow() {
      this.languageIsShow = !this.languageIsShow;
    },
    getHiddenChildrenMen(item) {
      let hiddenChildrenMenu = ["news", "knowledge"];
      if (hiddenChildrenMenu.includes(item.type)) {
        return false;
      }
      return true;
    },
    updataIsshow() {
      this.isShow = !this.isShow;
    },
    handleSearch() {
      if (this.searchVal) {
        window.location.replace(
          `${window.location.origin}/search?keywords=${this.searchVal}`,
        );
      } else {
        this.$message.error("Please enter the content!");
      }
    },
  },
};
